<template>
  <!-- 股东联盟 -->
  <div>
    <!-- 头部登录 -->
    <HeaderTop ref="shopcar"></HeaderTop>
    <Slider></Slider>
    <!-- 头部搜索和tabs -->
    <!-- <Header-Search :active="'shareholder'"></Header-Search> -->
    <div style="width: 100%; height: 2px; background: #377cf1"></div>
    <div class="center">
      <div class="supperHead">
        <div class="left">
          <div
            class="supperHead-gudong"
            v-show="carchecked == '1483458026179055616'"
          >
            <!-- <div class="headImg"> -->
            <img src="@/assets/images/home/ai.png" alt="股东联盟图片缺失" />
            <i>埃力克斯</i>
            <!-- <p>股东联盟</p> -->
            <!-- </div> -->
          </div>
          <div
            class="supperHead-gudong"
            v-show="carchecked == '1483458054591270912'"
          >
            <!-- <div class="headImg"> -->
            <img src="@/assets/images/home/ai1.png" alt="股东联盟图片缺失" />
            <i>艾森沃克</i>
            <!-- <p>股东联盟</p> -->
            <!-- </div> -->
          </div>
          <p @click="isChane = true">切换联盟</p>
          <div class="supperHead-change" v-show="isChane">
            <div
              v-for="item in shareholderList"
              :key="item.id"
              :class="carchecked === item.id ? 'checked' : ''"
              @click="checkedp(item)"
            >
              <span v-show="item.id == '1483458026179055616'">埃力克斯</span>
              <span v-show="item.id == '1483458054591270912'">艾森沃克</span>
            </div>
          </div>
        </div>

        <div class="right">
          <Input
            v-model="searchObj.keyword"
            placeholder="请输入配件编码/配件名称"
            style="width: 330px"
          />
          <Button
            type="primary"
            @click="selectEvent"
            :loading="selectLoading"
            style="margin: 0 38px 0 28px"
            >查询</Button
          >
        </div>
      </div>
      <Searchtop ref="searchTop"></Searchtop>
      <!-- <Tabs :value="tabName" :animated="false" @on-click="changeHandle"> -->
      <!-- <TabPane label="我的联盟" disabled name="name0"> -->
      <!-- <div class="emptyData">
            <h3>暂无联盟</h3>
          </div> -->
      <!-- </TabPane> -->
      <div>
        <!-- <TabPane
            v-for="item in shareholderList"
            :key="item.id"
            :label="item.tenantShortName"
            :name="item.id"
          > -->
        <!-- 搜索区域 -->
        <div class="selectBox">
          <div class="left">
            <div class="w110">
              发货仓：
              <span class="left-name"
                >{{ cehcekWarename
                }}<i class="ivu-icon ivu-icon-ios-arrow-down"></i
              ></span>
              <div class="left-warehouse">
                <span
                  @click="changeWare(item)"
                  v-for="item in warehouseLi"
                  :key="item.id"
                  :class="cehcekWare == item.id ? 'checked' : ''"
                  >{{ item.value }}{{ item.name }}</span
                >
              </div>
            </div>

            <!-- <Input
              v-model="searchObj.keyword"
              placeholder="请输入配件编码/配件名称(多配件查询用半角逗号分隔)"
              style="width: 330px; margin-left: 10px"
            /> -->
            <!-- <Select
                  style="width: 160px"
                  label-in-value
                  v-model="searchObj.partsType"
                  placeholder="配件类型"
                  @on-change="typeChange"
                  class="w150"
                >
                  <Option
                    v-for="item in partsTypeList"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.name }}</Option
                  >
                </Select>
                <Select
                  style="width: 160px"
                  label-in-value
                  v-model="searchObj.carBrandId"
                  placeholder="品牌"
                  class="w150"
                >
                  <Option
                    v-for="item in carBrandIdList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select> -->
            <!-- <Checkbox v-model="searchObj.inStock" @on-change="hasGoodsChange"
              >只显示有货</Checkbox
            >            -->
            <Checkbox v-model="searchObj.inStock" @on-change="hasGoodsChange"
              >只显示有货</Checkbox
            >
            <!-- <Checkbox v-model="searchObj.isActivity">只显示活动</Checkbox> -->
          </div>
          <div class="right">
            <!-- <Button type="primary" @click="selectEvent" :loading="selectLoading"
              >查询</Button
            >
            <Button @click="reset" type="primary">重置</Button> -->
            <!-- 分页 -->
            <div style="display: flex; justify-content: right">
              <Page
                :total="pager.total"
                :current="pager.current"
                :page-size="pager.size"
                size="small"
                :page-size-opts="[30]"
                show-total
                @on-change="changeCurrent"
                @on-page-size-change="changeSize"
              />
              <span
                style="
                  line-height: 11px;
                  height: 26px;
                  padding: 7px 10px;
                  border: 1px solid #dcdee2;
                  border-radius: 3px;
                "
                >30条/页</span
              >
            </div>
          </div>
        </div>

        <div class="boxs">
          <!-- <div class="box-left">
            <div class="box-left-span">
              <span class="iconfont icon-_dailijiameng"></span> 我的联盟
            </div>

            <p
              style="display: flex; font-size: 12px"
              @click="checkedp(item)"
              v-for="item in shareholderList"
              :key="item.id"
              :class="carchecked === item.id ? 'checked' : ''"
            >
              <img
                v-show="item.tenantShortName == 'JP-009-埃力克斯店'"
                style="width: 20px"
                src="@/assets/images/home/ai.png"
                alt=""
              />

              <img
                v-show="item.tenantShortName == 'JP-059-艾森沃克自主品牌部'"
                style="width: 20px"
                src="@/assets/images/home/ai1.png"
                alt=""
              />
              <span v-show="item.id == '1483458026179055616'"
                >JP-009&nbsp;&nbsp;&nbsp;&nbsp; 埃力克斯</span
              >
              <span v-show="item.id == '1483458054591270912'"
                >JP-059&nbsp;&nbsp;&nbsp; 艾森沃克</span
              >
            </p>
          </div> -->
          <div class="box-right">
            <!-- 表头 -->
            <Row class="tableHeader">
              <!-- <Col span="1"></Col> -->
              <Col span="4" style="margin-left: 10px">商品信息</Col>
              <Col span="3">OEM码</Col>
              <Col span="3">股东价格</Col>
              <Col span="2">库存</Col>
              <Col span="3">建议销售价</Col>
              <Col span="3">发货地</Col>
              <Col span="2" style="margin-left: 15px">购买数量</Col>
              <Col span="3" style="margin-left: 20px">操作</Col>
            </Row>
            <!-- 内容 -->
            <div class="table">
              <transition-group
                name="more"
                v-bind:css="false"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-if="show"
              >
                <div
                  class="tableCenter"
                  v-for="(item, index) in dataList"
                  :key="item.id"
                >
                  <Row :gutter="16" style="margin-left: 0">
                    <Col span="1"></Col>
                    <div class="mb10">
                      <div v-show="item.source">
                        {{ item.source }}
                      </div>
                    </div>
                  </Row>
                  <Row>
                    <!-- <Col span="1">
                      <div class="activeBox" v-if="item.type == 1">
                        <span class="iconfont icon-a-zu425"></span>
                        <p>优惠</p>
                      </div></Col
                    > -->
                    <Col span="4" class="detail" style="margin-left: 10px">
                      <div style="cursor: pointer">
                        <!-- <div class="partType">{{ item.typeName }}</div> -->
                        <div
                          class="partName"
                          @click="goDetails(item)"
                          style="max-width: 165px"
                        >
                          <span class="partType">{{ item.typeName }} </span>
                          {{ item.oeCode }}
                          {{ item.carBrandName }}
                          {{ item.direction }}{{ item.stdNameJp
                          }}{{ item.oilGrade }}
                        </div>
                      </div>
                      <ul style="padding-left: 4px">
                        <li>服务：</li>
                        <li v-if="item.genuineGuarantee">
                          <span class="iconfont icon-a-lujing153"></span>
                          <!-- <p>正品保证</p> -->
                        </li>
                        <!-- <li> -->
                        <li v-if="item.technicalSupport">
                          <span class="iconfont icon-a-ziyuan4"></span>
                          <!-- <p>技术支持</p> -->
                        </li>
                        <!-- <li> -->
                        <li v-if="item.warrantyService">
                          <span class="iconfont icon-a-ziyuan5"></span>
                          <!-- <p>保修服务</p> -->
                        </li>
                        <!-- <li> -->
                        <li v-if="item.returnPromise">
                          <span class="iconfont icon-a-ziyuan21"></span>
                          <!-- <p>退换货承诺</p> -->
                        </li>
                      </ul>
                      <!-- <div class="oe-p" @mouseleave="closeRelevance(index)">
                        OEM码：
                        <p
                          @mouseenter="getRelevance(item.partId, index, item)"
                          v-if="item.oemCodes.length"
                        >
                          {{ item.oemCodes[0]
                          }}<i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.oemCodes.length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.oemCodes.length > 1"
                        >
                          <div
                            class="relevanceBox"
                            :class="item.isShow ? 'show' : ''"
                          >
                            <p v-for="i in item.oemCodes.slice(1)" :key="i">
                              {{ i }}
                            </p>
                          </div>
                        </div>
                      </div> -->
                    </Col>
                    <Col span="3" class="w120">
                      <div class="oe-p" @mouseleave="closeRelevance(index)">
                        <p
                          class="w121"
                          @mouseenter="getRelevance(item.partId, index, item)"
                          v-if="item.oemCodes.length"
                        >
                          <span>{{ item.oemCodes[0] }}</span>
                          <i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.oemCodes.length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.oemCodes.length > 1"
                        >
                          <div
                            class="relevanceBox"
                            :class="item.isShow ? 'show' : ''"
                          >
                            <p v-for="i in item.oemCodes.slice(1)" :key="i">
                              {{ i }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <!-- <Col span="3" class="flexCenter">
                      <div class="shop">
                        <p @click="goShop(item)" style="cursor: pointer">
                          {{ item.shopName }}
                        </p>
                        <span>{{ item.provinceName }}{{ item.cityName }}</span>
                      </div>
                    </Col> -->
                    <Col span="3"
                      ><div class="price">
                        <div v-if="!item.inquiry">
                          <!-- <div> -->
                          <p>￥{{ item.price }}</p>
                          <span
                            v-if="item.type == 1"
                            class="iconfont icon-a-lujing156"
                          ></span>
                          <span v-if="item.type == 1">{{
                            item.activityTime
                          }}</span>
                        </div>
                        <p v-else>询价</p>
                      </div>
                    </Col>
                    <Col span="2" class="flexCenter"
                      >{{ item.stock &lt; 10 ? item.stock : '10+' }}/{{
                        item.unitId
                      }}</Col
                    >
                    <Col
                      span="3"
                      class="w133"
                      v-if="item.suggestedRetailPrice.length == 0"
                    >
                    </Col>
                    <Col
                      span="3"
                      class="w133"
                      v-if="item.suggestedRetailPrice == null"
                    >
                    </Col>
                    <Col
                      span="3"
                      class="w133"
                      v-if="item.suggestedRetailPrice.length > 0"
                    >
                      <p
                        v-for="i in item.suggestedRetailPrice.slice(0, 3)"
                        :key="i.id"
                        style="
                          font-weight: bold;
                          font-size: 10px;
                          color: #515a6e;
                        "
                      >
                        {{ i }}
                      </p>
                    </Col>
                    <!-- 发货地 -->
                    <Col span="3" class="w120">
                      <div class="oe-p" @mouseleave="closeCity(index)">
                        <p
                          class="w122"
                          @mouseenter="getCity(item.partId, index, item)"
                          v-if="item.shipCityStores.length"
                        >
                          {{ item.shipCityStore.city }}
                          {{ item.shipCityStore.name }}
                          <i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.shipCityStores.length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.shipCityStores.length > 1"
                        >
                          <div
                            class="relevanceBox w33"
                            :class="item.isShows ? 'show' : ''"
                          >
                            <p
                              v-for="i in item.shipCityStores"
                              :key="i.index"
                              class="w22"
                              :class="isCity === i.name ? 'isCityed' : ''"
                              @click="checkCITY(i, item)"
                            >
                              {{ i.city }}
                              {{ i.name }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col span="2" style="margin-left: 16px">
                      <div class="number">
                        <div class="number-in">
                          <Button
                            style="border-right: 1px solid #dcdee2"
                            class="number-sub"
                            @click="cliSub(item, index)"
                            :disabled="item.Sub"
                            >-</Button
                          >
                          <input
                            oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                            :id="index"
                            @blur="BlurNumber(item, index)"
                            v-model="item.maxNum"
                            style="
                              width: 53px;
                              text-align: center;
                              line-height: 31px;
                            "
                          />
                          <Button
                            class="number-add"
                            @click="cliAdd(item, index)"
                            :disabled="item.Add"
                            >+</Button
                          >
                        </div>
                        <div
                          class="number-sp"
                          :class="item.isNumber ? 'show' : ''"
                        >
                          库存不足
                        </div>
                      </div>
                    </Col>

                    <Col span="3" style="margin-left: 20px">
                      <div class="handle" v-if="tenantId !== item.tenantId">
                        <div
                          class="left"
                          style="justify-content: left !important"
                        >
                          <!-- 关注暂时隐藏 -->
                          <span
                            v-if="item.attention == true"
                            class="iconfont icon-a-ziyuan1"
                            title="收藏"
                            @click="getCollect(item)"
                          ></span>

                          <span
                            v-else
                            class="iconfont icon-a-lujing157"
                            title="收藏"
                            @click="getCollect(item)"
                          ></span>

                          <div v-if="!item.inquiry" class="regular">
                            <span
                              class="iconfont icon-a-zu420"
                              title="加入购物车"
                              @click="setShopCat(item, index)"
                            ></span>
                          </div>
                          <div v-else class="noregular">
                            <span class="iconfont icon-a-zu420"></span>
                          </div>
                          <xiaopei
                            style="padding-top: 3px"
                            :oppositeTenantId="item.tenantId"
                            :partId="item.partId"
                          >
                            <i class="iconfont icon-a-lujing162"></i
                          ></xiaopei>
                        </div>
                        <div class="right" v-if="item.inquiry == 0">
                          <Button
                            type="error"
                            @click="prebuy(item)"
                            :loading="item.buyLoading"
                            >立即购买</Button
                          >
                        </div>
                        <div class="right" v-if="item.inquiry == 1">
                          <Button @click="enquiry(item)" type="primary"
                            >立即询价</Button
                          >
                        </div>
                      </div></Col
                    >
                  </Row>
                </div>
              </transition-group>
              <!-- 数据为空 -->
              <div class="emptyData" v-if="dataList.length == 0">
                <p>
                  <span
                    ><i
                      ><Icon
                        type="ios-alert-outline"
                        size="17"
                      />没找到您想要的数据~</i
                    ></span
                  >
                </p>
              </div>
              <!-- 加载中 -->
              <div class="demo-spin-container" v-if="spinShow">
                <Spin fix></Spin>
              </div>
            </div>
          </div>
        </div>
        <!-- </TabPane> -->
      </div>
      <!-- </Tabs> -->
      <div style="display: flex; justify-content: right">
        <Page
          :total="pager.total"
          :current="pager.current"
          :page-size="pager.size"
          size="small"
          :page-size-opts="[30]"
          show-total
          @on-change="changeCurrent"
          @on-page-size-change="changeSize"
        />
        <span
          style="
            line-height: 11px;
            height: 26px;
            padding: 7px 10px;
            border: 1px solid #dcdee2;
            border-radius: 3px;
          "
          >30条/页</span
        >
      </div>
    </div>
    <Footer></Footer>
    <FooterP></FooterP>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
  </div>
</template>

<script>
import Slider from '../base/common/slider.vue'
import Searchtop from '../components/searchTop.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import HeaderTop from '../base/common/header-top.vue'
// import HeaderSearch from '../base/common/header-search.vue'
import FooterP from '../base/common/footer-p.vue'
import Footer from '../base/common/footer.vue'
import enquirytk from '@/views/base/common/enquirytk.vue'
import { listData } from '@/views/base/common/listData.js'
import {
  getDataListworld,
  getDataList,
  getLeagueForTenant,
  getattention,
  getWare
  // getListAllLabel,
  // getListPartsType,
  // getListAllBrand
} from '@/api/goodsList.js'

export default {
  mixins: [listData],
  components: {
    Slider,
    Searchtop,
    HeaderTop,
    // HeaderSearch,
    FooterP,
    Footer,
    xiaopei,
    enquirytk
  },
  data() {
    return {
      isCity: '',
      aa: ['1个以上：230.00元', '5个以上：220.00元', '10个以上：210.00元'],
      cehcekWarename: '',
      cehcekWare: '',
      warehouseLi: [],
      isChane: false,
      carchecked: '',
      carBrandIdList: [],
      partsTypeList: [],
      enquirydata: {}, // 询价的数据
      shareholderList: [''],
      tabName: 'name0',
      isActivity: false,
      hasGoods: false,
      selectLoading: false,
      model1: '',
      cityList: [],

      searchObj: {
        // carBrandId: '-1',
        // partsType: '-1',
        keyword: '',
        inStock: false,
        isActivity: ''
      },
      sureObj: {
        // carBrandId: '-1',
        // partsType: '-1',
        keyword: '',
        inStock: false,
        isActivity: ''
      },
      searchData: {
        storeId: '',
        // carBrandId: '-1',
        // partsType: '',
        area: 3,
        brandId: '',
        current: 1,
        inStock: '',
        isActivity: '',
        keyword: '',
        leagueId: '',
        partType: '',
        priceSort: '', // 价格查询排序,
        shopId: '',
        size: 30,
        stockSort: '' // 库存查询排序
      }
    }
  },
  created() {
    // this.getListPartsType()
    // this.getDataList()
    this.getLeagueForTenant()
  },
  methods: {
    // 立即询价
    enquiry(item) {
      console.log(item)
      this.enquirydata = JSON.parse(JSON.stringify(item))
      this.$refs.enquirytkl.enquirytkc()
    },
    // 询价刷新
    enquirysx() {
      this.$refs.shopcar.getenquirydata()
    },
    // 收藏
    async getCollect(item) {
      console.log(item, 'item')
      item.attention = !item.attention
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      const res = await getattention({
        partId: item.partId,
        attention: item.attention
      })
      console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
    },
    // 获取联盟
    async getLeagueForTenant() {
      let id = JSON.parse(
        localStorage.getItem('userdetails_leagueInfo')
      ).tenantId
      console.log(id)
      let res = await getLeagueForTenant({
        id
      })
      console.log(res)
      if (res.status == true) {
        this.shareholderList = res.data.list
        const arr = JSON.parse(JSON.stringify(res.data.list))
        let arr1 = []
        //  arr1 = arr.filter((item)=>{
        //     return item.id ==='1483458026179055616' || item.id ==='1483458054591270912'
        //   })
        arr.forEach((item) => {
          if (item.id === '1483458026179055616') {
            arr1.push(item)
          }
          if (item.id === '1483458054591270912') {
            arr1.push(item)
          }
        })
        // console.log(arr1)
        this.shareholderList = arr1
        this.carchecked = this.shareholderList[0]
          ? this.shareholderList[0].id
          : ''
        // this.tabName = this.shareholderList[0] ? this.shareholderList[0].id : ''
        this.searchData.leagueId = this.shareholderList[0]
          ? this.shareholderList[0].id
          : ''
        // console.log(this.shareholderList)
        // console.log(this.carchecked)
        const val = await getWare({ tenantId: this.searchData.leagueId })
        console.log(val)
        if (val.status) {
          this.warehouseLi = val.data
          if (this.warehouseLi.length > 0) {
            this.cehcekWare = this.warehouseLi[0].id
            this.cehcekWarename =
            this.warehouseLi[0].value + this.warehouseLi[0].name  
          }

          this.getDataList()
        }
      }
    },
    // 展示发货地
    getCity(partId, index, item) {
      // console.log(partId)
      console.log(item, item.isShows)
      this.isCity = item.shipCityStore.name
      // this.isCity = item.oemCodes[0]
      // console.log(this.isCity)
      this.$set(this.dataList[index], 'isShows', true)
    },
    // 获取了数据
    async getDataList() {
      this.show = true
      this.searchData.storeId = this.cehcekWare
      // this.searchData.carBrandId = this.sureObj.carBrandId
      // this.searchData.partsType = this.sureObj.partsType
      this.searchData.keyword = this.sureObj.keyword.trim()
      // this.searchData.inStock = this.sureObj.inStock ? 1 : ''
      // this.searchData.isActivity = this.sureObj.isActivity ? 1 : ''
      // console.log(this.searchData)
      this.spinShow = true
      let res = await getDataListworld(this.searchData)
      console.log(res)
      if (res.status == true) {
        this.$nextTick(() => {
          this.brandArr = res.data.partBrandVOList
          this.PartsTypeArr = res.data.partsTypeList
          this.$refs.searchTop.getListBrandType(this.brandArr)
          this.$refs.searchTop.getListPartsType(this.PartsTypeArr)
          this.dataList = res.data.ipage.records
          this.pager.total = res.data.ipage.total
          this.getMaxNum()
        })
      } else {
        this.dataList = []
        this.$refs.searchTop.getListBrandType([])
        this.$refs.searchTop.getListPartsType([])
      }
      this.spinShow = false
      this.selectLoading = false
    },
    // 切换联盟（新版样式）
    async checkedp(val) {
      this.reset()
      this.$refs.searchTop.checkedType = '-1'
      this.$refs.searchTop.checkedBrand = '-1'
      // this.$refs.searchTop.getListBrandType()
      this.searchData.leagueId = val.id
      this.carchecked = val.id
      const res = await getWare({ tenantId: val.id })
      console.log(res)
      if (res.status) {
        this.warehouseLi = res.data
        if (this.warehouseLi.length > 0) {
          this.cehcekWare = this.warehouseLi[0].id
          this.cehcekWarename = this.warehouseLi[0].name
        }
      }
      this.cehcekWare = this.warehouseLi[0].id
      this.cehcekWarename = this.warehouseLi[0].name
      this.changeListsBtn()
      this.isChane = false
    },
    checkCITY(i, item) {
      console.log(i, item)
      this.isCity = i.name
      item.shipCityStore = i
      item.stock = i.stock
    },
    // 切换仓库
    changeWare(item) {
      console.log('1111')
      console.log(item)
      this.cehcekWarename = item.value + item.name  
      this.cehcekWare = item.id
      this.searchData.current = 1
      this.searchData.size = 30
      this.pager.current = 1
      this.pager.size = 30
      this.getDataList()
    },
    // 切换联盟
    // changeHandle(name) {
    //   // console.log(name)
    //   this.searchData.leagueId = name
    //   this.reset()
    //   this.changeListsBtn()
    // },
    // 查询
    selectEvent() {
      this.selectLoading = true
      console.log(this.searchObj.inStock)
      // this.sureObj.carBrandId = this.searchObj.carBrandId
      // this.sureObj.partsType = this.searchObj.partsType
      // this.sureObj.storeId =
      this.sureObj.keyword = this.searchObj.keyword
      this.sureObj.inStock = this.searchObj.inStock
      this.sureObj.isActivity = this.searchObj.isActivity
      // 重置分页
      this.changeListsBtn()
    },
    // 重置
    reset() {
      this.searchObj = {
        keyword: '',
        inStock: false,
        isActivity: false
      }
      this.sureObj = {
        keyword: '',
        inStock: false,
        isActivity: false
      }
      this.searchData = {
        carBrandId: '',
        partsType: '',
        area: 3,
        brandId: '',
        current: 1,
        inStock: '',
        isActivity: '',
        keyword: '',
        leagueId: '',
        partType: '',
        priceSort: '', // 价格查询排序,
        shopId: '',
        size: 10,
        stockSort: '' // 库存查询排序
      }
      // this.carchecked = this.shareholderList[0]
      //   ? this.shareholderList[0].id
      //   : ''
      // this.tabName = this.shareholderList[0] ? this.shareholderList[0].id : ''
      // this.searchData.leagueId = this.shareholderList[0]
      //   ? this.shareholderList[0].id
      //   : ''
      // this.hasGoods = false,
      this.searchData.keyword = ''
      this.searchData.inStock = ''
      // this.getDataList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../supportself/index.less';
@import './index.less';
// a {
//   display: flex;
// }
</style>
